var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasItems
    ? _c(
        "div",
        { staticClass: "radioButton" },
        [
          _vm._l(_vm.prepareItems, function (item, index) {
            return _c(
              "label",
              {
                ref: "radioButton-" + index,
                refInFor: true,
                staticClass: "radioButton__label",
                class: _vm.intClasses(item),
              },
              [
                _vm.labelSide === "left"
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "radioButton__labelText radioButton__labelText--left",
                      },
                      [_vm._v(_vm._s(_vm.hasLabel(item)))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasCustomRadioIcon,
                      expression: "hasCustomRadioIcon",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: item.checked,
                      expression: "item.checked",
                    },
                  ],
                  staticClass: "radioButton__input",
                  attrs: {
                    name: _vm.groupName,
                    type: "radio",
                    required: item.required,
                    disabled: item.disabled,
                  },
                  domProps: { checked: _vm._q(item.checked, null) },
                  on: {
                    input: function ($event) {
                      return _vm.updateValue(item, $event)
                    },
                    change: function ($event) {
                      return _vm.$set(item, "checked", null)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._t("customRadioIcon"),
                _vm._v(" "),
                _vm.labelSide === "right"
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "radioButton__labelText radioButton__labelText--left",
                      },
                      [_vm._v(_vm._s(_vm.hasLabel(item)))]
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.error
            ? _c("span", { staticClass: "radioButton__error" }, [
                _vm._v(_vm._s(_vm.error)),
              ])
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }